import { render, staticRenderFns } from "./AddressTree.vue?vue&type=template&id=2be72410&scoped=true"
import script from "./AddressTree.vue?vue&type=script&lang=js"
export * from "./AddressTree.vue?vue&type=script&lang=js"
import style0 from "./AddressTree.vue?vue&type=style&index=0&id=2be72410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be72410",
  null
  
)

export default component.exports